import script from "./footerText.vue?vue&type=script&setup=true&lang=ts"
export * from "./footerText.vue?vue&type=script&setup=true&lang=ts"

import "./footerText.vue?vue&type=style&index=0&id=3f3f10e2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f3f10e2"]])

export default __exports__